<template>
    <div id="app">
        <!-- <the-loader v-if="!showContent"></the-loader> -->
        <transition name="fade" mode="out-in">
            <the-navbar>
                <div
                    v-for="(menuItem, key) in menuItems"
                    v-show="menuItem.show" :key="key"
                    class="navbar-item"
                >
                    <router-link
                        v-if="$route.name != 'home' || !menuItem.homeScroll"
                        :to="menuItem.to"
                    >{{ menuItem.name }}</router-link>
                    <a
                        v-if="$route.name == 'home' && menuItem.homeScroll"
                        href="#"
                        @click.prevent=""
                        v-scroll-to="menuItem.scroll"
                    >{{ menuItem.name }}</a>
                </div>
            </the-navbar>
        </transition>
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
        <transition name="fade" mode="out-in">
            <the-footer></the-footer>
        </transition>
        <the-modal v-if="showModal && $i18n.locale=='pl'"></the-modal>
		<cookies />
    </div>
</template>

<script>
import axios from 'axios';
import { eventBus } from './event-bus.js'
import TheNavbar from './components/TheNavbar.vue'
import TheFooter from './components/TheFooter.vue'
import TheModal from './components/TheModal.vue'
import Cookies from './components/Cookies.vue'
// import TheLoader from './components/TheLoader.vue'

export default {
    name: 'app',
    components: {
        'the-navbar': TheNavbar,
        'the-footer': TheFooter,
        'the-modal': TheModal,
		'cookies': Cookies
        // 'the-loader': TheLoader
    },
    metaInfo(){
        if(this.$i18n.locale === 'pl')
            return {
                title: 'Wyzwania podatkowe SSW Pragmatic Solutions',
                titleTemplate: '%s | Wyzwania podatkowe SSW Pragmatic Solutions',
            }
        else
            return {
                title: 'Tax and legal challenges for 2019 SSW Pragmatic Solutions',
                titleTemplate: '%s | Tax and legal challenges SSW Pragmatic Solutions',
            }
    },
    data () {
        return {
            pages: Object,
            blocks: Object,
            showModal: false,
            mods: null,
            menuItems: [
                {
                    name: this.$t("home"),
                    show: true,
                    to: '/',
                    scroll: '#home',
                    homeScroll: true
                },
                {
                    name: this.$t("challenges"),
                    show: true,
                    to: '/#wyzwania-podatkowe',
                    scroll: '#wyzwania-podatkowe',
                    homeScroll: true
                },
                {
                    name: this.$t("contact"),
                    show: true,
                    to: '/#kontakt',
                    scroll: '#kontakt',
                    homeScroll: true
                }
            ]
        }
    },
    computed:{
        getCurrentPageName(){
            // if there is home route then load page with slug home
            let componentName = this.$route.path;
            if(this.$route.path == '/'){
                componentName = 'home'
            } else {
                componentName = componentName.split('/');
                componentName = componentName[componentName.length - 1];
            }
            return componentName
        }
    },
    methods: {
        checkIfPageHasChildren(id){
            // flag default to false
            var hasChildren = false;
            // map thru object looking for children of ID's parent
            Object.keys(this.pages).map((objectKey) => {
                // get whole object
                let value = this.pages[objectKey];
                if(value.parent == id){
                    // even if at least one children is in pages then return true for all
                    hasChildren = true
                }
            });
            return hasChildren
        }
    },
    created() {
        this.showModal = (process.env.VUE_APP_SHOW_MODAL == 'true') ? true : false;
    }
}
</script>

<style lang="sass">
</style>
